import React from 'react';
import { motion } from 'framer-motion';
export function ModulesGrid() {
  const tomos = [{
    id: 1,
    emoji: '📗',
    title: 'Fundamentos de la Gestión Ambiental',
    subtitle: 'Todo lo que necesitás saber antes de entrar al aula o dar tu primera clase ambiental',
    desc: 'Definición de ambiente y sus componentes, historia de la gestión ambiental, desarrollo sostenible y ODS, principios ambientales internacionales, legislación ambiental argentina (Ley 25.675, Ley 27.621, Ley Yolanda), problemáticas ambientales actuales en Argentina y el rol de la Educación Ambiental Integral. Con guías de lectura, vocabulario de referencia y material imprimible listo para usar en clase.',
    resuelve: 'El primer contacto del alumno con la Gestión Ambiental es decisivo. Este tomo te da la base legal, conceptual e histórica para hablar con autoridad desde el primer día del ciclo lectivo.',
    resultado: 'Tus alumnos sienten que están aprendiendo algo real, urgente y conectado con Argentina. El Art. 41 de la Constitución, la Ley Yolanda y el fallo Mendoza del Riachuelo cobran vida en el aula.',
    tags: ['LEGISLACIÓN', 'PRINCIPIOS AMBIENTALES', 'ODS', 'HISTORIA', 'PROBLEMÁTICAS ARGENTINAS']
  }, {
    id: 2,
    emoji: '📗',
    title: 'Recursos Naturales y Conservación',
    subtitle: 'Conocé la riqueza ambiental de Argentina como si la hubieras recorrido entera',
    desc: 'Clasificación de recursos naturales, biodiversidad argentina, ecosistemas nacionales, áreas protegidas, manejo sustentable, uso responsable del agua, conservación de suelos, flora y fauna en peligro. Todo con ejemplos del Acuífero Guaraní, los glaciares andinos, la Selva Misionera, el Gran Chaco y el Mar Argentino.',
    resuelve: 'Cuando un alumno pregunta "¿para qué sirve conservar algo que no veo?", este tomo te da la respuesta exacta con el yaguareté de Misiones, el litio de la Puna y el humedal que los protege de las inundaciones.',
    resultado: 'Convertís cada clase en una experiencia significativa porque tus ejemplos son del territorio que tus alumnos habitan y del futuro que van a heredar.',
    tags: ['BIODIVERSIDAD', 'ECOSISTEMAS', 'ÁREAS PROTEGIDAS', 'AGUA', 'FAUNA EN PELIGRO']
  }, {
    id: 3,
    emoji: '📗',
    title: 'Gestión de Residuos y Economía Circular',
    subtitle: 'Argentina genera 46.000 toneladas de basura por día. Aprendé a enseñar la solución.',
    desc: 'Tipos y clasificación de residuos, separación en origen, reciclaje y reutilización, compostaje, economía circular y las 9R, gestión integral de residuos urbanos (GIRU), legislación vigente y casos argentinos exitosos. Con la Cooperativa El Ceibo, la Ley de Basura Cero de Buenos Aires y el biogás del CEAMSE como casos reales.',
    resuelve: 'Un alumno que entiende la diferencia entre economía lineal y circular, que sabe qué es la Responsabilidad Extendida del Productor y que puede diseñar el sistema de residuos de su escuela es un ciudadano transformador.',
    resultado: 'Tus alumnos no solo aprenden a separar la basura. Aprenden a pensar el sistema que la genera y a proponer alternativas reales.',
    tags: ['RECICLAJE', 'COMPOSTAJE', 'ECONOMÍA CIRCULAR', '9R', 'LEGISLACIÓN']
  }, {
    id: 4,
    emoji: '📗',
    title: 'Contaminación y Control Ambiental',
    subtitle: 'El tomo que te transforma de docente de ambiente a intérprete de la realidad ambiental argentina',
    desc: 'Contaminación del aire, agua y suelo, contaminación sonora, evaluación de impacto ambiental (EIA), técnicas de monitoreo, indicadores ambientales y medidas de mitigación. Con el smog del AMBA, el arsénico en el agua subterránea, el glifosato en la Pampa Húmeda y el pasivo ambiental de Dock Sud como casos reales.',
    resuelve: 'Enseñar contaminación no es solo enumerar contaminantes. Es la herramienta que te permite conectar la ciencia con los derechos ambientales y con las decisiones que afectan la vida cotidiana de tus alumnos.',
    resultado: 'Podés llevar la realidad del país al aula y hacer que tus alumnos entiendan por qué el barrio más contaminado siempre es el más pobre, y qué pueden hacer al respecto.',
    tags: ['CONTAMINACIÓN', 'EIA', 'MONITOREO', 'REMEDIACIÓN', 'LEGISLACIÓN']
  }, {
    id: 5,
    emoji: '⭐',
    title: 'Cambio Climático y Sostenibilidad',
    subtitle: 'Que cada concepto que enseñés tenga impacto real en el futuro de tus alumnos',
    desc: 'Bases científicas del cambio climático, el efecto invernadero, huella de carbono, energías renovables, adaptación y mitigación climática, acuerdos internacionales (Acuerdo de París, COP) y la situación de Argentina frente al cambio climático. Con los glaciares andinos, Vaca Muerta y la transición energética argentina.',
    resuelve: 'El cambio climático es el mayor desafío del siglo. Este tomo convierte cada clase en una lección de ciudadanía climática argentina con datos actualizados al 2026.',
    resultado: 'Tus alumnos comprenden que el cambio climático no está en el futuro: está en los glaciares que se derriten, en las inundaciones que se repiten y en las decisiones que Argentina toma hoy sobre sus recursos.',
    tags: ['CAMBIO CLIMÁTICO', 'HUELLA DE CARBONO', 'ENERGÍAS RENOVABLES', 'ACUERDO DE PARÍS', 'VACA MUERTA'],
    badge: '⭐ EL MÁS POPULAR'
  }, {
    id: 6,
    emoji: '📗',
    title: 'Proyectos Ambientales Escolares',
    subtitle: 'El tomo que cierra el ciclo y convierte el conocimiento en transformación institucional real',
    desc: 'Diseño de proyectos ambientales con metodología ABP, diagnóstico institucional ambiental, elaboración de objetivos SMART, planificación de actividades, indicadores de seguimiento, informes ambientales, campañas de comunicación y ferias de ciencias ambientales. Con 3 proyectos completos como modelos.',
    resuelve: 'Saber gestión ambiental no alcanza. Este tomo te da el marco metodológico para que tus alumnos diseñen, implementen y evalúen proyectos que cambian su escuela y su barrio.',
    resultado: 'Pasás de enseñar contenidos sueltos a liderar una institución que actúa sobre el ambiente. Tus alumnos terminan el año con un proyecto real que tiene impacto medible.',
    tags: ['PROYECTOS', 'ABP', 'OBJETIVOS SMART', 'INDICADORES', 'FERIAS DE CIENCIAS', 'IMPACTO REAL']
  }];
  const bonos = [{
    id: 1,
    title: '100 Actividades Ambientales para el Aula',
    valor: '$18.000 ARS',
    desc: 'Más de 100 actividades listas para usar: individuales, grupales, debates ambientales, juegos educativos, análisis de casos argentinos, proyectos rápidos y actividades interdisciplinarias. Todo contextualizado en Argentina. Sin preparación adicional del docente. Organizadas por tiempo disponible: desde 10 minutos hasta clase completa.'
  }, {
    id: 2,
    title: '100 Evaluaciones Listas para Imprimir',
    valor: '$15.000 ARS',
    desc: 'Evaluaciones de opción múltiple, verdadero/falso con justificación, desarrollo, casos prácticos argentinos, rúbricas de evaluación y autoevaluaciones. Con claves de corrección completas. Listo para fotocopiar y aplicar en el momento que lo necesitás.'
  }, {
    id: 3,
    title: '6 Proyectos Ambientales Escolares Listos',
    valor: '$20.000 ARS',
    desc: 'Seis proyectos institucionales completamente diseñados: Huerta Escolar Sustentable, Compostaje Institucional, Reciclaje Escolar Integral, Campaña de Ahorro de Agua, Energía Sustentable Escolar y Forestación Escolar Nativa. Cada uno con ficha técnica, diagnóstico, objetivos SMART, cronograma anual, actividades detalladas, indicadores y presupuesto estimado.'
  }, {
    id: 4,
    title: 'Efemérides Ambientales 2026',
    valor: '$12.000 ARS',
    desc: '52 efemérides ambientales con ficha completa, datos de Argentina, acto escolar con guión listo, actividades por nivel, campaña para redes sociales y recursos digitales. Del Día Mundial del Agua al Día del Árbol en Argentina: nunca más improvisás una efeméride.'
  }];
  return <section className="py-20 bg-[#ece2cd]" data-id="element-161">
      <div className="container mx-auto px-4" data-id="element-162">
        <div className="text-center mb-16" data-id="element-163">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1e4230] text-[#e7c766] border border-[#c8971b]/40 font-bold mb-6 text-[15px]" data-id="element-164">
            📗 LOS 6 TOMOS
          </div>
          <h2 className="text-[24px] md:text-5xl font-black text-[#1e4230] mb-4 font-[Merriweather,_serif]" data-id="element-165">
            Un tomo por cada dimensión de la Gestión Ambiental Argentina
          </h2>
          <p className="text-[#6f4e2e] font-medium text-[16px]" data-id="element-166">
            Todo el sistema didáctico resuelto para docentes de Argentina.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto mb-20" data-id="element-167">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`rounded-2xl border bg-white overflow-hidden shadow-[0_10px_28px_-16px_rgba(31,50,39,0.3)] hover:shadow-[0_16px_38px_-16px_rgba(31,50,39,0.4)] transition-all flex flex-col h-full relative ${tomo.badge ? 'border-[#c8971b] border-2' : 'border-[#e0d6bf]'}`} data-id="element-168">
              {tomo.badge && <div className="absolute top-0 right-0 bg-[#c8971b] text-[#14301f] font-black text-xs px-3 py-1 rounded-bl-lg z-10" data-id="element-169">
                  {tomo.badge}
                </div>}
              <div className="bg-[#1e4230] p-4 border-b-4 border-[#c8971b] flex items-center gap-3" data-id="element-170">
                <div className="text-3xl" data-id="element-171">{tomo.emoji}</div>
                <div data-id="element-172">
                  <p className="text-xs font-bold uppercase tracking-wider text-[#e7c766]" data-id="element-173">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-[#f5efe1] text-lg leading-tight font-[Merriweather,_serif]" data-id="element-174">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-175">
                <p className="font-semibold text-[#6f4e2e] mb-3 pb-3 border-b border-[#e0d6bf]" data-id="element-176">
                  {tomo.subtitle}
                </p>
                <p className="text-[#4a4133] text-sm leading-relaxed mb-4" data-id="element-177">
                  {tomo.desc}
                </p>
                <div className="bg-[#f5efe1] p-3 rounded-lg mb-4 border border-[#e0d6bf]" data-id="element-178">
                  <p className="text-xs text-[#6f4e2e] mb-1" data-id="element-179">
                    <strong data-id="element-180">¿Qué resuelve en tu aula?</strong>
                  </p>
                  <p className="text-sm text-[#4a4133]" data-id="element-181">{tomo.resuelve}</p>
                </div>
                <div className="bg-[#eaf3ec] p-3 rounded-lg mb-4 border border-[#c6e0cf]" data-id="element-182">
                  <p className="text-xs text-[#2f6b47] mb-1" data-id="element-183">
                    <strong data-id="element-184">Resultado:</strong>
                  </p>
                  <p className="text-sm text-[#1e4230]" data-id="element-185">{tomo.resultado}</p>
                </div>
                <div className="mt-auto flex flex-wrap gap-1.5" data-id="element-186">
                  {tomo.tags.map((tag, j) => <span key={j} className="text-[10px] font-bold uppercase tracking-wider bg-[#e5ddc8] text-[#6f4e2e] px-2 py-1 rounded" data-id="element-187">
                      {tag}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-12 border-t border-[#d3c8ac] pt-16" data-id="element-188">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#c8971b] text-[#14301f] font-bold mb-6 text-[15px]" data-id="element-189">
            🎁 LOS 4 BONOS ESTRATÉGICOS
          </div>
          <h2 className="text-[22px] md:text-4xl font-black text-[#1e4230] mb-4 font-[Merriweather,_serif]" data-id="element-190">
            Siempre incluidos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-12" data-id="element-191">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#e0d6bf] bg-white p-6 flex flex-col h-full relative overflow-hidden shadow-[0_10px_28px_-16px_rgba(31,50,39,0.25)]" data-id="element-192">
              <div className="absolute top-0 left-0 w-full h-1.5 bg-[repeating-linear-gradient(90deg,#c8971b,#c8971b_10px,#6f4e2e_10px,#6f4e2e_20px)]" data-id="element-193"></div>
              <h4 className="font-bold text-[#a97e12] mb-2 mt-2" data-id="element-194">
                BONO 0{bono.id}
              </h4>
              <h3 className="font-bold text-[#1e4230] text-lg mb-3 font-[Merriweather,_serif]" data-id="element-195">
                {bono.title}
              </h3>
              <p className="text-xs font-bold text-[#6f4e2e] mb-4 pb-3 border-b border-[#e0d6bf]" data-id="element-196">
                Valor real: <span className="line-through" data-id="element-197">{bono.valor}</span> →{' '}
                <span className="text-[#2f6b47]" data-id="element-198">GRATIS</span>
              </p>
              <p className="text-[#4a4133] text-sm leading-relaxed flex-grow" data-id="element-199">
                {bono.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-[#1e4230] rounded-2xl p-6 md:p-8 border-2 border-[#c8971b]/50 text-center shadow-2xl" data-id="element-200">
          <p className="text-[#d8d0bd] font-medium mb-2" data-id="element-201">
            Valor total de los 4 bonos: $65.000 ARS
          </p>
          <p className="text-2xl md:text-3xl font-black text-[#f5efe1] mb-2" data-id="element-202">
            Tu precio hoy: <span className="text-[#e7c766]" data-id="element-203">🎁 GRATIS</span> con
            tu Megapack
          </p>
        </motion.div>
      </div>
    </section>;
}